

export const privateDefaultRoute = '/console';
export const publicDefaultRoute = '/';

export const extenal = {
    docs: 'http://docs.smartmonkey.io/#/flake/getting_started',
};

export const root = '/';
export const register = '/register';
export const resetPassword = '/reset-password';
export const login = '/login';
export const userValidation = '/user/validate/:token';
export const userNewPassword = '/user/new-password/:token';
export const logout = '/logout';

export const cookiesPolicy = '/docs/cookies_policy.pdf';

export const console = {
    root: '/console',
    activityExecution: '/console/activity/execution/:id',
    requests: '/console/requests',
    key: '/console/keys/:id',
    keys: '/console/keys',
    users: '/console/users',
};

